import { useNavigate } from "react-router-dom";

import { Dashboard } from "@/app/dashboard/Dashboard";
import { useAppContext } from "@/app/providers/AppContext";

/**
 * JS-1090b: routed shell for the audit-grade outcome ledger + performance
 * surface. A dedicated route (mirrors EditionPortalPage) rather than the
 * `/portal/:tabId` single-segment scheme, positioned before that catch-all
 * for the same static-segment-specificity reason documented in App.tsx.
 *
 * JS-1094 (demo blocker FIX 1): renders INSIDE the same `Dashboard` portal
 * shell every other routed page uses (see WatchCreatePortalPage's identical
 * pattern) -- rendering the bare `LedgerPage` content directly (the
 * pre-JS-1094 behavior) dropped the sidebar entirely, orphaning the ledger
 * with no way back into the rest of the portal short of the browser Back
 * button.
 */
export default function LedgerPortalPage() {
  const navigate = useNavigate();
  const { profile, entitlements, api, loading } = useAppContext();

  return (
    <Dashboard
      tabId="trade-ideas-ledger"
      profile={profile}
      entitlements={entitlements}
      loading={loading}
      api={api}
      onUpgrade={() => navigate("/portal/plans")}
      onNewWatch={() => navigate("/portal/watches/new")}
      onTabChange={(tabId) => navigate(`/portal/${tabId}`)}
    />
  );
}
